import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { TagsInput } from '@components/Form/Autocomplete'
import Input from '@components/Form/Input'
import Button from '@components/Button'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'

class LinkContractsForm extends Component {
  state = {
    contracts: [],
    loading: true
  }

  componentDidMount () {
    const { contractStore } = this.props
    const { contract } = contractStore
    contractStore
      .getParentAccountContracts(contract.parentAccountId)
      .then(contracts => {
        const linkedContractIds = contract.linkedContracts.map(c => c.id)
        this.setState({
          contracts: contracts.filter(
            c => c.id !== contract.id && !linkedContractIds.includes(c.id)
          ),
          loading: false
        })
      })
  }

  render () {
    const { contractStore, title } = this.props

    if (this.state.loading) {
      return null
    }

    return (
      <div>
        <h1>{title}</h1>
        <Formik
          initialValues={{
            contracts: [],
            linkReason: null
          }}
          render={form => (
            <Form onSubmit={form.handleSubmit}>
              <div className='expert-form__section'>
                <Field
                  label='Contracts'
                  form={form}
                  name='contracts'
                  placeholder='Select contracts to link'
                  options={this.state.contracts}
                  itemToString={item => item && item.contractReference}
                  component={TagsInput}
                />
                <Field
                  label='Link reason'
                  form={form}
                  name='linkReason'
                  component={Input}
                />
              </div>
              <div className='expert-form__section expert-form__section--buttons'>
                <Button
                  primary
                  submit
                  onClick={this.onSubmit}
                  disabled={form.isSubmitting}
                >
                  {this.props.okText}
                </Button>
                <Button
                  onClick={this.props.modalStore.close}
                  disabled={form.isSubmitting}
                >
                  {this.props.cancelText}
                </Button>
              </div>
            </Form>
          )}
          onSubmit={(values, action) => {
            contractStore
              .linkContracts(
                values.contracts.map(c => c.id),
                values.linkReason
              )
              .then(this.props.modalStore.close)
          }}
        />
      </div>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object,
    modalStore: PropTypes.object,
    title: PropTypes.string,
    okText: PropTypes.string,
    cancelText: PropTypes.string
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: false,
    shouldCloseOnOverlayClick: false
  }
}

export default inject('modalStore')(observer(LinkContractsForm))
